document.addEventListener('DOMContentLoaded', function() {
    const movementStrength = 1000;
    const height = movementStrength / window.innerHeight;
    const width = movementStrength / window.innerWidth;
    const elements = document.querySelectorAll('.photo-grid__inner-container');
    let isThrottled = false;

    elements.forEach(function(element) {
        element.addEventListener('mousemove', function(e) {
            if (isThrottled) return;
            isThrottled = true;

            setTimeout(() => {
                isThrottled = false;
            }, 100);

            requestAnimationFrame(() => {
                const pageX = e.pageX - (element.offsetWidth / 2);
                const pageY = e.pageY - (element.offsetHeight / 2);
                const newvalueX = width * pageX * -1 - 25;
                const newvalueY = height * pageY * -1 - 50;
                element.style.backgroundPosition = `${newvalueX}px ${newvalueY}px`;
            });
        });
    });
});
